// extracted by mini-css-extract-plugin
export default {"price":"u7-z","priceRow":"v7-z","onSale":"w7-z","msrpLabelPrice":"x7-z","msrpLabel":"y7-z","originalPrice":"z7-z","percentOff":"A7-z"};